import { BowelMovementTemplate } from "../../../features/reporting/templates/BowelMovementTemplate";

export function BowelMovementScreen() {
  return <BowelMovementTemplate />;
}
